import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { grey } from '@mui/material/colors';
import {styled} from '@mui/system';


const StyledCallMadeIcon = styled(CallMadeIcon)({
    verticalAlign: -2,
    fontSize: 'small',
    cursor: 'pointer'
});

const StyledLinkDefault = styled(Link)({
    textDecoration: 'none',
    '&:hover':{
        textDecoration: 'underline'
    }
});

const StyledLinkDisabled = styled(StyledLinkDefault)({
     color: grey[500]
});


class Linkout extends React.Component {
    constructor(props) {
        super(props);
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    render() {
        let StyledLink = this.props.disabled ? StyledLinkDisabled : StyledLinkDefault;
        return (
            <StyledLink target="_blank" rel="noreferrer" onClick={this.stopPropagation}
                  href={this.props.url}>
                {this.props.label} <StyledCallMadeIcon />
            </StyledLink>
        );
    }

}

Linkout.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};


export default Linkout;

